export default __webpack_public_path__ + "static/media/Luxury_box_4.ce6d0b97.png";